function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { aiStudioPalette } from '@guryou/colors';
import styled from 'styled-components';
import { SurfaceCard } from './SurfaceCard';

// Shared "profile page" primitives — promoted out of the Coaching module's
// module-local coaching/components/ui.js (originally the AI Studio 2 design
// language) so any profile-style page (Athlete profile, Customer AI-360, …)
// can build its shell from one real component, not a third parallel copy.

const T = aiStudioPalette;
export const PageWrap = styled.div`
  min-height: 100%;
  background: ${T.paper};
  color: ${T.ink};
  padding: 24px 24px 60px;
`;
export const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.3px;
  color: ${T.ink};
  margin: 0 0 3px;
`;
export const PageSub = styled.p`
  font-size: 13px;
  color: ${T.muted2};
  margin: 0 0 18px;
  max-width: 760px;
`;
export const CardGrid = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fill, minmax(${p => p.min || 290}px, 1fr));
`;
export const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${T.muted3};
  margin-bottom: ${p => p.tight ? 0 : 8}px;
`;
export const BigNumber = styled.div`
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: ${T.ink};
  line-height: 1.15;
`;

// KPI card with the 3px top accent strip — pure composition over SurfaceCard.
export const KpiCard = ({
  accent,
  ...props
}) => /*#__PURE__*/React.createElement(SurfaceCard, _extends({
  accentTop: accent || T.coral,
  padding: "14px 16px"
}, props));
export const RowLine = ({
  label,
  value
}) => /*#__PURE__*/React.createElement("div", {
  style: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    padding: '3px 0',
    fontSize: 13
  }
}, /*#__PURE__*/React.createElement("span", {
  style: {
    color: T.muted2
  }
}, label), /*#__PURE__*/React.createElement("span", {
  style: {
    fontWeight: 500,
    textAlign: 'right',
    color: T.ink
  }
}, value === null || value === undefined || value === '' ? '—' : value));
export const AVATAR_PALETTE = aiStudioPalette.avatars;
export const avatarColor = id => {
  const s = String(id || '');
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 997;
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
};
export const initials = (first, last) => `${(first || '?')[0] || ''}${(last || '')[0] || ''}`.toUpperCase();